import dayjs from 'dayjs';
import formatDate from './formatDate';

/**
 * Ð§Ð¸ÑÐ°ÐµÐ¼Ð¾Ðµ Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð² â Ð´Ð»Ñ ÑÑÑÐ¾ÐºÐ¸ Â«ÑÑÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ð¾ÑÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°Ð½Ð¾Â»
 * Ð½Ð°Ð´ ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹. ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐµÑ Ð¶Ðµ Ð¾Ð±ÑÐµÐºÑÐ¾Ð² Ð¾Ð¿ÑÐ¸Ð¹, Ð¸Ð· ÐºÐ¾ÑÐ¾ÑÑÑ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑÑÑ
 * Ð·Ð°Ð¿ÑÐ¾Ñ (HookForm ÐºÐ»Ð°Ð´ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð² item.value), ÑÑÐ¾Ð±Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑ Ð½Ðµ ÑÐ°Ð·ÑÐµÐ·Ð¶Ð°Ð»Ð°ÑÑ
 * Ñ ÑÐµÐ¼, ÑÑÐ¾ ÑÐµÐ°Ð»ÑÐ½Ð¾ ÑÑÐ»Ð¾ Ð½Ð° Ð±ÑÐº.
 */
const asText = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'object') {
    // Ð¡ÐµÐ»ÐµÐºÑ Ð¾ÑÐ´Ð°ÑÑ { value, label }, Ð´Ð°ÑÐ°Ð¿Ð¸ÐºÐµÑ â Ð´Ð°ÑÑ.
    if (value.label !== undefined && value.label !== null) return String(value.label);
    return dayjs(value).isValid() ? formatDate(value) : null;
  }
  return String(value);
};

const describeFilters = (options = []) =>
  options
    .map((option) => ({
      name: option.name,
      label: option.label || option.title || option.name,
      text: asText(option.value),
    }))
    .filter((item) => item.text);

export default describeFilters;
